import React from 'react';
import './css/CreatorCard.css';
import LazyImage from '../../components/LazyImage/LazyImage';
import { DEFAULT_USER_AVATAR, ROLE } from '../../shared/constants/common';
import ViewProfileButton from '../buttons/ViewProfileButton';
import FollowPPVCreatorButton from '../buttons/FollowPPVCreatorButton';
import {
  getSubscriptionPriceWithExtraCharge,
  getUserSubscriptionPrice,
  getFormFieldValue
} from '../../shared/utils/paymentUtil';
import {
  getSubscriptionDateText,
  calculateDaysRemaining,
  getCdnProfileUrl
} from '../../shared/utils/function';
import { truncateUsernameDisplay } from '../../shared/utils/usernameFormat';

const CreatorCard = ({
  index,
  creator,
  vatPercentage = 0,
  isShowSubscriptionPrice,
  isAllowFollowOrUnfollow,
  onFollowSuccess,
  onUnfollowSuccess,
  tab = null,
}) => {
  // Determine if this is a subscription-based creator (rol: 1) or follow-based (rol: 3)
  const isSubscriptionBased = creator.rol === ROLE.CREATOR_SUB;
  const isFollowBased = creator.rol === ROLE.CREATOR_CONTENT;
  const displayPrice = creator.price && creator.price !== "NaN" ?
    `${getSubscriptionPriceWithExtraCharge(creator.price, creator?.active_promotion, vatPercentage)}`
    : null;
  const isFollowing = creator.isFollowing || false;
  const isSubscribed = creator.isSubscribed || false;
  const profileImgUrl = getCdnProfileUrl(creator?.avatar || creator?.profile_picture, DEFAULT_USER_AVATAR);
  const authorUserName = creator.username || '';
  const isTrending = creator.isTrending || false;
  const isFeature = creator.isFeature || false;
  const userAppliedPromotion = creator?.applied_promotion && Object.keys(creator?.applied_promotion).length > 0 ?
    creator?.applied_promotion : null;
  const initialPrice = creator?.paymentForm ? getFormFieldValue(creator?.paymentForm, 'initialPrice') : undefined;


  return (
    <div className={`modern-creator-card modern-creator-card--subscribed ${isFeature ? 'is_trending' : ''}`}>
      <div className="modern-card-image-container">
        <div className="modern-card-image-bg">
          <LazyImage
            src={profileImgUrl}
            alt={`${authorUserName} profile`}
            className="modern-creator-avatar"
            onError={(e) => {
              e.target.src = DEFAULT_USER_AVATAR;
            }}
          />
        </div>

        {(isFeature || isTrending) && (
          <div className='show_bage_wrap'>
            {isFeature && (
              <i className="fa fa-star"></i>
            )}
            {isTrending && (
              <i className="fa fa-fire"></i>
            )}
          </div>
        )}

        <div className={`modern-creator-badge ${isSubscriptionBased ? 'modern-creator-badge--subscription' : 'modern-creator-badge--follow'}`}>
          <i className={`fa-solid ${isSubscriptionBased ? 'fa-calendar' : 'fa-plus'} modern-badge-icon`}></i>
        </div>
      </div>

      <div className={`modern-card-content ${isFollowBased && !isSubscribed ? 'modern-card-content--centered' : ''}`}>
        <div className="modern-card-info modern-card-info_equal">
          <h3 className="modern-creator-name">
            {truncateUsernameDisplay(authorUserName)}
          </h3>

          {isSubscribed && creator?.expire_at && (
            <div className="modern-renewal-info mb-3">
              {getSubscriptionDateText(
                creator.expire_at,
                creator.state,
                tab,
                userAppliedPromotion && Object.keys(userAppliedPromotion).length > 0 ? true : false
              )}
            </div>
          )}

          {isSubscriptionBased && displayPrice && (
            isSubscribed && isShowSubscriptionPrice ? (
              calculateDaysRemaining(creator.expire_at) >= 0 ? (
                <div
                  className={`modern-price-info ${tab === 'all-creators' ? 'all-creators-price-info' : 'subscriptions-price-info'}`}
                >
                  {((userAppliedPromotion && Object.keys(userAppliedPromotion).length > 0)
                    || (initialPrice === 0 || initialPrice === undefined)) ? (
                    getUserSubscriptionPrice(creator.price, creator.paidAmount, userAppliedPromotion, vatPercentage)
                  ) : (
                    `$${initialPrice}/mo`
                  )}
                </div>
              ) : (
                <div
                  className={`modern-price-info ${tab === 'all-creators' ? 'all-creators-price-info' : 'subscriptions-price-info'}`}
                >
                  {displayPrice}
                </div>
              )
            ) : !isSubscribed && (
              <div
                className={`modern-price-info ${tab === 'all-creators' ? 'all-creators-price-info' : 'subscriptions-price-info'}`}
              >
                {displayPrice}
              </div>
            )
          )}
        </div>

        {/* Show Follow button for follow-based creators */}
        {isFollowBased && (
          <>
            {isAllowFollowOrUnfollow ? (
              <FollowPPVCreatorButton
                creator={creator}
                onFollowSuccess={onFollowSuccess}
                onUnfollowSuccess={onUnfollowSuccess}
              >
                <button className={`follow-btn ${isFollowing ? 'following' : ''}`}>
                  {isFollowing ? 'Following' : 'Follow'}
                </button>
              </FollowPPVCreatorButton>
            ) : (
              <button
                className={`follow-btn ${isFollowing ? 'following' : ''} disabled`}
                disabled
                title={isFollowing ? 'You are following this creator' : 'Follow action not available'}
              >
                {isFollowing ? 'Following' : 'Follow'}
              </button>
            )}
          </>
        )}

        {/* Always show View Profile button */}
        <ViewProfileButton creator={creator}>
          <button className={`modern-view-profile-btn ${isFollowing ? 'following' : ''}`}>
            View Profile
          </button>
        </ViewProfileButton>
      </div>
    </div>
  );
};

export default CreatorCard;

